// sessionUtils.ts
import { useNavigation } from "@react-navigation/native"
import flash from "config/flash"
import { translate } from "i18n"
import { useStores } from "models"

export const useSessionExpired = () => {
  const navigation = useNavigation()
  const { userStore, couponStore } = useStores()

  const sessionExpired = () => {
    flash("error", translate("errors.sessionExpired"))
    navigation.reset({ index: 0, routes: [{ name: "auth" }] })
    couponStore?.clearCoupon()
    userStore?.logout()
  }

  return { sessionExpired }
}
